import React from 'react';

/**
 * This PITL Patient Acknowledgement changes if an affiliate code is used.
 */
const PITLPatientAcknowledgement = ({ hasAffiliateCode }) => {
	if (hasAffiliateCode) {
		return (
			<div>
				<p>
					Please review the full{' '}
					<a
						href="https://connect.gdx.net/terms-and-conditions"
						target="_blank"
						rel="noopener noreferrer"
						title="Terms and Conditions"
					>
						terms and conditions
					</a>{' '}
					and{' '}
					<a
						href="/files/connect/Cynergy Wellness Informed Consent Document.pdf"
						target="_blank"
						rel="noopener noreferrer"
						title="Authorization and Consent for Diagnostic Testing"
					>
						Cynergy consent
					</a>{' '}
					prior to submitting this order.
				</p>
			</div>
		);
	}
	return (
		<div>
			<p>
				Please review the full{' '}
				<a
					href="https://connect.gdx.net/terms-and-conditions"
					target="_blank"
					rel="noopener noreferrer"
					title="Terms and Conditions"
				>
					terms and conditions
				</a>
				,{' '}
				<a
					href="/files/connect/Cynergy Wellness Informed Consent Document.pdf"
					target="_blank"
					rel="noopener noreferrer"
					title="Authorization and Consent for Diagnostic Testing"
				>
					Cynergy consent
				</a>{' '}
				and{' '}
				<a
					href="https://connect.gdx.net/refund-policy"
					target="_blank"
					rel="noopener noreferrer"
					title="Refund Policy"
				>
					refund policy
				</a>{' '}
				prior to submitting this order.
			</p>
			<p>
				The total charges for your order include shipping and handling, physician authorization, and performance
				of the laboratory test(s), and will be charged as soon as you submit the order. A portion of the charges
				will be non-refundable as soon as the order is submitted. If payment is declined or a chargeback occurs
				after the order is submitted, then Genova Diagnostics reserves the right to cancel the order or send a
				statement for up to the total charges. This order is not billable to insurance.
			</p>
		</div>
	);
};

const PITLPatientAcknowledgementCheckboxText = ({ hasAffiliateCode }) => {
	if (hasAffiliateCode) {
		return <>I have read and fully understand the conditions listed above.</>;
	}

	return (
		<>
			I have read and fully understand the conditions listed above, and I give authorization for Genova
			Diagnostics to charge me for the total charges.
		</>
	);
};

export { PITLPatientAcknowledgementCheckboxText };
export default PITLPatientAcknowledgement;
